<template>
  <div>
    <div class="text-3xl mb-8">Berichte</div>
    <div class="shadow rounded overflow-hidden items-center">
      <stats-date-picker v-slot:default="{ dateFrom, dateTo }">
        <key-figures :dateFrom="dateFrom" :dateTo="dateTo"></key-figures>
      </stats-date-picker>
    </div>
  </div>
</template>


<script>
import StatsDatePicker from '@/components/reporting/StatsDatePicker';
import KeyFigures from '@/components/reporting/KeyFigures';

export default {
  components: {
    StatsDatePicker,
    KeyFigures,
  },
};
</script>



